/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Org_NameInputs */

const en_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const de_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const fr_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const es_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const it_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const nl_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const pl_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const fi_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const da_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

const sv_privacy_org_name = /** @type {(inputs: Privacy_Org_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EliteX GbR`)
};

/**
* | output |
* | --- |
* | "EliteX GbR" |
*
* @param {Privacy_Org_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_org_name = /** @type {((inputs?: Privacy_Org_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Org_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_org_name(inputs)
	if (locale === "fr") return fr_privacy_org_name(inputs)
	if (locale === "es") return es_privacy_org_name(inputs)
	if (locale === "it") return it_privacy_org_name(inputs)
	if (locale === "nl") return nl_privacy_org_name(inputs)
	if (locale === "pl") return pl_privacy_org_name(inputs)
	if (locale === "fi") return fi_privacy_org_name(inputs)
	if (locale === "da") return da_privacy_org_name(inputs)
	if (locale === "sv") return sv_privacy_org_name(inputs)
	return en_privacy_org_name(inputs)
});